import axios from "axios";
import { toast } from "react-toastify";
import getCompanyIdFromToken from "../../utils/getCompanyIdFromToken";
import { createAsyncThunk } from "@reduxjs/toolkit";

const companyId = getCompanyIdFromToken();

// Get Roles
export const getRoles = async () => {
  // const { data } = await axios.get(`role?query=all`);
  const { data } = await axios.get(`roles/RoleDetailsGetbyCompanyId`);
  // console.log('data', data);
  
  return data;
};

// Create Role

export const addRole = async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      
      url: `/roles/RoleDetailsSetup`,
      data: {
        ...values,
      },
    });
    //dispatching data
    toast.success("Added successful");

    return {
      data,
      message: "success",
    };
  } catch (error) {
    toast.error("Error in adding Role try again");
    // console.log(error.message);
    return {
      message: "error",
    };
  }
};

// Detail Role View

export const loadSingleRole = async (RoleId) => {
  try {
    const { data } = await axios.get(`roles/MenuPermissionGetByRoleId?RoleId=${RoleId}`);
    return {
      data,
      message: "Success",
    };
  } catch (error) {
    // console.log(error.message);
  }
};

//Add Permission in Role

export const addPermission = async (values) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `roles/RolePermissionSetup`,
      data: {
        ...values,
      },
    });
    //dispatching data
    toast.success("Added successful");

    return {
      data,
      message: "success",
    };
  } catch (error) {
    toast.error("Error in adding Permission try again");
    // console.log(error.message);
    return {
      message: "error",
    };
  }
};

// Get Permsiion
export const loadPermission = async () => {
  const { data } = await axios.get(`permission?query=all`);
  return data;
};

export const loadSinglePermission = async() =>{
  
}
// delete Role permissions
export const deleteRolePermission = async (value) => {
  try {
    const { data } = await axios({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      url: `role-permission?query=deletemany`,
      data: value,
    });
    //dispatching data
    toast.success("Deleted successful");

    return {
      data,
      message: "success",
    };
  } catch (error) {
    toast.error("Error in deleting Permission try again");
    // console.log(error.message);
    return {
      message: "error",
    };
  }
};

export const EmployeeRoleHistorySetup = createAsyncThunk(
	"shift/EmployeeRoleHistorySetup",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `employee/EmployeeRoleHistorySetup`,
				data: {
					...values,
				},
			});
			toast.success("Employment Status Added");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Employment Status try again");
			// console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);
